<template>
    <div class="my_purse">
        <h3>我的钱包</h3>
        <ul class="box">
            <li>
                <h3>可用余额</h3>
                <div>
                    <h3>当前冻结余额：￥<span v-if="money.money_total">{{money.money_total.disabled_money_sum}}</span></h3>
                    <ul>
                        <li v-for="item in money.custom_money" :key="item.money_id">
                            <h3>{{item.money_classify}}</h3>
                            <p>￥<span>{{item.have_money}}</span></p>
                        </li>
                    </ul>
                </div>
            </li>
            <li>
                <h3>信用额度</h3>
                <div>
                    <h3>当前冻结信用：￥<span v-if="credit.credit_total">{{credit.credit_total.disabled_money_sum}}</span></h3>
                    <ul>
                        <li>
                            <h3>当前信用额度</h3>
                            <p>￥<span v-if="credit.credit_money">{{credit.credit_money.have_money}}</span></p>
                        </li>
                    </ul>
                </div>
            </li>
            <li>
                <h3>交易记录</h3>
                <div>
                    <el-table
                        v-loading="isReload"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        :data="money_detail.detail"
                        border
                  
                        style="width: 100%"
                    >
                        <el-table-column
                        prop="type"
                        label="类型">
                        </el-table-column>
                        <el-table-column
                        prop="money"
                        label="金额">
                        </el-table-column>
                        <el-table-column
                        prop="money_type"
                        label="方式">
                        </el-table-column>
                        <el-table-column
                        prop="create_date"
                        label="日期">
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 分页   -->
                <div class="cut_page">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        v-if="lastPage>1"
                        :page-count='lastPage'
                        :current-page='currentPage'
                        @current-change="current_change"
                        @prev-click="prev_click"
                        @next-click="next_click">
                    </el-pagination> 
                </div>
            </li>
        </ul>
    </div>
</template>
<script>

export default {
    name:'my_purse',
    data(){
        return{
            // 信用额度
            credit:{},
            // 余额
            money:{},
            // 交易记录
            money_detail:{},
            // 是否加载
            isReload:true,
            // 当前页
            currentPage:1,
            // 总页
            lastPage:0,
        }
    },
    methods:{
        // 获取页面数据的ajax
        getPageAjax(p){
            this.$http({
                url: 'my_purse',
                data: {
                    page:p
                }
            }).then((res)=>{
                this.isReload=false
                if(res.code==1){
                    this.money_detail=res.data.money_detail
                    this.money=res.data.money
                    this.credit=res.data.credit
                    this.currentPage=res.data.money_detail.page.currentPage
                    this.lastPage=res.data.money_detail.page.lastPage
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 点击分页中的某一页
        current_change(e){
            this.currentPage=e
            this.getPageAjax(this.currentPage)
        },
        //前一页
        prev_click(e){
            this.currentPage=e--
            this.getPageAjax(this.currentPage)
        },
        //后一页
        next_click(e){
            this.currentPage=e++
            this.getPageAjax(this.currentPage)
        }
    },
    created(){
        this.getPageAjax(this.currentPage)
    }
}
</script>
<style lang="scss" scoped>
.my_purse{
    height:100%;
    padding:20px 0 30px;
    >h3{
        text-align: center;
        font-size:22px;
        line-height:50px;
        font-weight:600;
    }
}
.box{
    >li{
        padding-bottom:20px;
        >h3{
            border-left:4px solid #FF9933;
            padding-left:27px;
            font-size:24px;
            line-height:24px;
            margin:30px 0;
        }
        >div{
            height:200px;
            border-radius:5px;
            background:#F8F8F8;
            margin:0 30px;
            padding-top:30px;
            >h3{
                background:white;
                margin:0 30px;
                height:50px;
                line-height:50px;
                padding:0 20px;
                color:#FF9933;
                font-size:18px;
            }
            >ul{
                display:flex;
                align-items:center;
                justify-content: space-around;
                margin:0 30px;
                height:120px;
                >li{
                    text-align:center;
                    // border-right:1px solid #DDDDDD;
                    p{
                        color:#FF9933;
                        font-size:24px;
                        line-height:50px;
                    }
                }
                // >li:nth-child(2n){
                //     width:1px;
                //     height:30px;
                //     border-right:1px solid #DDDDDD;
                // }
            }
        }
    }
    >li:last-child{
        padding:0;
        >div{
            height:auto;
            padding:0;
        }
    }
}

</style>
<style  scoped>
.box >>> .cut_page {
    background:white;
    margin-top:30px;
    display: flex;
    justify-content: flex-end;
}
</style>
